import { render, staticRenderFns } from "./appOrderAddEdit.vue?vue&type=template&id=25b626e8"
import script from "./appOrderAddEdit.vue?vue&type=script&lang=js"
export * from "./appOrderAddEdit.vue?vue&type=script&lang=js"
import style0 from "./appOrderAddEdit.vue?vue&type=style&index=0&id=25b626e8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports